import * as React from "react";

export function ComingSoonTag() {
  return (
    <div className="text-blue-700 bg-blue-100 rounded-md p-1 text-xs">
      Coming Soon
    </div>
  );
}
